import { useContext, useEffect, useReducer} from "react";
import {AuthContext} from "./AuthContext";
import {logger} from "../common/logger";
import {configureFetch} from "./AuthenticatedService";
import { medsUserApi } from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { setMedicationsPermissions } from "@communicare/medications/Config/PermissionConfig";
import { IdentityContext } from "./UserIdentity";

type IdentityActions = 'Start_Loading_Identity'|'Identity_Loaded'|'Identity_Loading_Failed'
function reducer(state:any,action:{type:IdentityActions;payload:any}):any{
    logger.log(action.type);
    switch (action.type) {
        case "Start_Loading_Identity":
            return {
                ...state,
                action:action.type
            };
        case "Identity_Loaded":
            return {
                ...state,
                action:action.type,
                success:action.payload,
                error:null
            };
        case "Identity_Loading_Failed":
            return {
                ...state,
                action:action.type,
                success:null,
                error:action.payload
            };
        default:
            return state;
    }
}

export const useIdentity=()=>{
    let [authState, dispatch] = useReducer(reducer,{
        action:null,
        error:null,
        success:null
    });
    let auth = useContext(AuthContext);
    let ctx = useContext(IdentityContext);
    const loadIdentity=async ()=>{
        let userInfo = await medsUserApi.getMedUserInfo();
        let identityInfo = await auth?.userData;        
        return {
            email:identityInfo?.email,
            userName:identityInfo?.userName,
            familyName:userInfo?.externalUserInfo?.familyName,
            givenName:userInfo?.externalUserInfo?.givenName,
            permissions:userInfo?.identity.permissions,
            userType:userInfo?.userType,
            isShared:userInfo?.isShared,
            userId:userInfo?.userId,    
            isClinicalIdentityProviderUser: userInfo?.isClinicalIdentityProviderUser,
            externalUserName: userInfo?.externalUserInfo?.userName
        }
    };
    useEffect(()=>{
        if (!auth?.isLoading) {
            auth?.signIn();
        }
        
    },[]);

    
    useEffect(()=>{
        if (auth?.userData && authState.action!=='Start_Loading_Identity' && !authState.success){
            configureFetch(auth.userManager);
            dispatch({
                type:"Start_Loading_Identity",
                payload:null
            });
            loadIdentity().then(x=>{
                setMedicationsPermissions(x?.permissions||[]);
                ctx?.setUserInfo(x as any);
                dispatch({
                    type:"Identity_Loaded",
                    payload:{
                        ...x,
                        signIn:auth?.signIn,
                        signOut:auth?.signOutRedirect
                    }
                });

            }).catch(err=>{                
                dispatch({
                    type:"Identity_Loading_Failed",
                    payload:err
                });
            });
        }
    },[auth?.userData, ctx])
    
    return {
        loading:authState.action==='Start_Loading_Identity' || !auth?.userData,
        identity:authState.success,
        error:authState.error,
        loggedOut:authState.loggedOut
    };
}

